// extracted by mini-css-extract-plugin
export default {"datasheets":"DataSheets-datasheets-217"};